import React from 'react';
import {
  Card,
  Row,
  Col,
  Menu,
  Dropdown,
  Image
} from "antd";
import fileUtils from "../../../utils/file-utils";
import { EditOutlined, DeleteOutlined, LinkOutlined, FolderOpenOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const { Meta } = Card;

function getValue(value) {
  if (value) {
    return value.id
  } else {
    return null;
  }
}

// const RenderButton = ({ removeDisplay, editDisplay, displayId, removeId }) => {
//   return (
//     <>
//       <Button
//         style={{
//           position: 'absolute',
//           backgroundColor: '#f5f5f5',
//           border: '0px',
//           top: '0px',
//           right: '70px',
//           fontSize: '18px',
//           color: '#b3b3b3',
//           cursor: 'pointer',
//           whiteSpace: "normal",
//           height: 'auto',
//           marginBottom: '10px'
//         }}
//         onClick={() => editDisplay(displayId)}>
//         <EditOutlined />
//       </Button>

//       <Popconfirm
//         title="ยืนยันการลบข้อมูล ?"
//         onConfirm={() => removeDisplay(removeId)}
//         okText="ยืนยัน"
//         cancelText="ยกเลิก" >
//         <Button
//           style={{
//             position: 'absolute',
//             backgroundColor: '#f5f5f5',
//             border: '0px',
//             top: '0px',
//             right: '0px',
//             fontSize: '18px',
//             color: '#b3b3b3',
//             cursor: 'pointer',
//             whiteSpace: "normal",
//             height: 'auto',
//             marginBottom: '10px'
//           }}>
//           <DeleteOutlined />
//         </Button>
//       </Popconfirm>
//     </>
//   )
// };

const SortableItem = ({ value, onRemove, groupValue, onEdit, embedMenuList, editMenuList, openMenuList, moveFile, onDownload, onClick }) => {
  const folderFlag = value.folder;
  const valueData = value;
  const path = value.path
  const attachImage = value.fileName;
  const id = getValue(value);
  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: "image",
      item: value,
      collect: (monitor) => ({
        isDragging: monitor.isDragging()
      })
    }),
    []
  );

  const [{ isOver }, dropRef] = useDrop(() => ({
    accept: "image",
    drop: (item) => dropFunct(item)
  }));

  const dropFunct = async (itemMove) => {
    moveFile(itemMove, value);
  }

  const menuList = (
    <Menu >
      <Menu.Item key="embedMenuPhotoList">
        <a key="embedPhotoClick" onClick={() => embedMenuList(id)}>
          <LinkOutlined /> Embed
        </a>
      </Menu.Item>
      <Menu.Item key="editMenuPhotoList">
        <a key="editPhotoClick" onClick={() => editMenuList(valueData)}>
          <EditOutlined /> แก้ไข
        </a>
      </Menu.Item>
      <Menu.Item key="downloadMenuPhotoList">
        <a key="downloadPhotoClick" onClick={() => onDownload(valueData)}>
          <DownloadOutlined /> ดาวน์โหลด
        </a>
      </Menu.Item>
      <Menu.Item key="deleteMenuPhotoList">
        <a key="removePhotoClick" onClick={() => onRemove(id)}>
          <DeleteOutlined /> ลบ
        </a>
      </Menu.Item>
    </Menu>
  );

  const menuDocumentList = (
    <Menu >
      <Menu.Item key="embedMenuFolderList">
        <a key="embedFolderClick" onClick={() => openMenuList(valueData)}>
          <FolderOpenOutlined /> เปิด
        </a>
      </Menu.Item>
      <Menu.Item key="editMenuFolderList">
        <a key="editFolderClick" onClick={() => editMenuList(valueData)}>
          <EditOutlined /> แก้ไข
        </a>
      </Menu.Item>
      <Menu.Item key="deleteMenuFolderList">
        <a key="removeFolderClick" onClick={() => onRemove(id)}>
          <DeleteOutlined /> ลบ
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <Col span={6} key={id}>
      {folderFlag ? (
        <div ref={dropRef} onDoubleClick={() => openMenuList(valueData)}>
          <Dropdown overlay={menuDocumentList} trigger={['contextMenu']}>
            <Card
              className="w-100"
              cover={<img src="/assets/icon-folder.png" />}
            >
              {/* <RenderButton removeDisplay={onRemove} editDisplay={onEdit} displayId={valueData} removeId={id} /> */}
              {/* <RemoveButton removeDisplay={onRemove} displayId={id}></RemoveButton>
                      <EditButton editDisplay={onEdit} displayId={valueData}></EditButton> */}
              <p className="mb-0" >{valueData.fileName ? <Meta title={valueData.fileName} description={valueData.totalView ? valueData.totalView : '0'} /> : <Meta title={valueData.folderName} />}</p>
            </Card>
          </Dropdown>
        </div>
      ) : (
        <div
          key={`card-${id}`}
          className="site-dropdown-context-menu"
          ref={dragRef}
        >
          <Dropdown overlay={menuList} trigger={['contextMenu']}>
            <Card
              className="w-100 cursor-pointer"
              cover={<Image src={fileUtils.getGalleryRenderUrl(
                groupValue,
                path,
                attachImage,
              )}
                download
                preview={false}
              />}
              onClick={()=>onClick(valueData)}
            >
              {/* <RenderButton removeDisplay={onRemove} editDisplay={onEdit} displayId={valueData} removeId={id} /> */}
              <p className="mb-0" >{valueData.fileName ? (<Meta title={valueData.fileName} description={valueData.totalView ? valueData.totalView : '0'} />) : <Meta title={valueData.folderName} />}</p>
            </Card>
          </Dropdown>
        </div>
      )
      }
    </Col>
  );
};

const GalleryPhoto = ({ items, onRemove, groupValue, onEdit, embedMenuList, editMenuList, openMenuList, folderValue, moveFile, onDownload, onClick }) => {
  return (
    <>
      <Row gutter={30}>
        <DndProvider backend={HTML5Backend}>
          {items.map((value, index) => (
            <SortableItem
              key={`sortable-${getValue(value)}`}
              index={index}
              value={value}
              onRemove={onRemove}
              groupValue={groupValue}
              onEdit={onEdit}
              embedMenuList={embedMenuList}
              editMenuList={editMenuList}
              openMenuList={openMenuList}
              folderValue={folderValue}
              moveFile={moveFile}
              onDownload={onDownload}
              onClick={onClick}
            />
          ))}
        </DndProvider>
      </Row>
    </>
  );
};

export default GalleryPhoto;
